import { isValidURL } from "../../../../helpers";
import { TValidator } from "../../../wizard/types";
import { IAcademicFormModelHigher } from "../../types";

const validator: TValidator = async ({
  values,
}: {
  values: IAcademicFormModelHigher;
}) => {
  const errors: {
    [key: string]: any;
  } = {};

  const degreeId = values.selectedDegree.id;
  const degree = values.degrees?.[values.selectedDegree.id];

  if (!degree || !degree.requiredDocs || degree.requiredDocs.length < 4) {
    errors.requiredDocs = "Please select at least 4";
  }

  if (degree?.applicationLink && !isValidURL(degree.applicationLink)) {
    errors.applicationLink = "Please insert a valid URL";
  }

  if (Object.keys(errors).length > 0) {
    throw {
      degrees: {
        [degreeId]: errors,
      },
    };
  }
};

export default validator;
